import React from "react";

import SmallIconButton from "components/Buttons/SmallIconButton";

const BasicCloseIcon = React.forwardRef<HTMLButtonElement, any>(
  (props, ref) => {
    return (
      <SmallIconButton {...props} ref={ref}>
        <span className="material-icons-outlined">close</span>
      </SmallIconButton>
    );
  },
);

export default BasicCloseIcon;
